import { fetchFrequencyManagementSettings } from 'modules/frequencyManagement/lib/queries/fetchFrequencyManagementSettings';
import { useGraphql } from 'utils/hooks/useGraphql';
import { ConfigByMediumSerialized } from 'modules/frequencyManagement/lib/types';

export const useFetchFrequencyManagement = ({ skip = false }: { skip?: boolean } = {}) =>
  useGraphql<ConfigByMediumSerialized>(fetchFrequencyManagementSettings, { skip });
